import styles from './styles.module.scss';

import { useContext, useEffect, useState } from 'react';
import { Board } from '../../../components/Board';
import { ModuleOption } from '../../../components/ModuleOption';
import { MODULES, Module } from '../../../modules/config/ModulesList';
import { Agent } from '../../../components/Agent';
import { LogicManagerSidebar } from '../../../components/LogicManagerSidebar';
import { ProfileBox } from '../../../components/ProfileBox';
import {
    getPronoun,
    handleTextVariables,
    hasPermission,
    verifyRoutePermissions
} from '../../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import { User } from '../../../types';
import { LoadingContext } from '../../../providers/LoadingProvider';
import { MessageContext } from '../../../providers/MessageProvider';
import { ModuleStatus } from './types';
import { loadModulesStatus } from './requestHandlers';
import { MessageBox } from '../../../components/MessageBox';
import moment from 'moment';
import TrilogicUserManual from '../../../assets/files/trilogic_manual_do_usuario_v1.pdf';
import { NavButton } from '../../../components/NavButton';
import lockerIcon from '../../../assets/images/icons/locker.png';
import { BotaoAcessibilidade } from '../../../components/BotaoAcessibilidade';
import { MenuAcessibilidade } from '../../../components/MenuAcessibilidade';
import { transform } from 'lodash';
import axios, { AxiosRequestConfig } from 'axios';
import { SettingsEthernetSharp } from '@mui/icons-material';



export const HubRoute = () => {
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const { setIsLoadingPage } = useContext(LoadingContext);
    const navigate = useNavigate();
    const [acessivel, setAcessivel] = useState<boolean>(false)
    const ModoAcessivel = () => {
        setAcessivel(!acessivel)
    }
    const [personagem, setPersonagem] = useState()
    const [modulesStatus, setModulesStatus] = useState<ModuleStatus[]>([]);
    const [introFeedback, setIntroFeedback] = useState<string>('');
    const [showMessageBox, setShowMessageBox] = useState<boolean>(false);
    const [showAcessibilidade, setShowMenu] = useState<boolean>(false);
    const [questionarioRespondido, setRespondido] = useState<boolean>(false);
    const [nivel, setNivel] = useState<number>(1)
    const [testes, setTestes] = useState()

    const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${userAuth.token}`,
                    Accept: 'application/json'
                }
            };

    const handleOnPressFeedback = () => {
        const currentDate = moment().utc(true).format('YYYY-MM-DD');
        localStorage.setItem('intro', currentDate);
        setShowMessageBox(false);
    };

    const showUserManual = () => {
        window.open("https://drive.google.com/file/d/1duQvul5wvSyLWlu6REa2hhn5kbDUuL1A/view?usp=drive_link");
    };

    const showMenuAcessibilidade = () => {
        setShowMenu(!showAcessibilidade);
    };


    const handleFeedbackIntro = (message: string) => {
        const notified = localStorage.getItem('intro');
        const currentDate = moment().utc(true).format('YYYY-MM-DD');
        const pronoun = getPronoun(userAuth.gender);
        const content = handleTextVariables(message, [
            { variable: '{nome}', value: userAuth.name },
            { variable: '{desinencia}', value: pronoun }
        ]);

        setIntroFeedback(content);

        if (notified !== currentDate) {
            setShowMessageBox(true);
        }
    };

    const handleLoadModulesStatus = async () => {
        setIsLoadingPage(true);
        const result = await loadModulesStatus(userAuth.token, navigate);
        setIsLoadingPage(false);
        console.log(result)

        if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
            setModulesStatus(result.modules as ModuleStatus[]);
            handleFeedbackIntro(result.intro);
        } else {
            const error = result as Error;
            setMessage({ type: 'error', content: error.message });
            setOpenMessage(true);
        }
    };


    const handleCharacter = async () => {
        var result
        try {
            result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/user`, { userId: userAuth.id })
            console.log(result)
            setPersonagem(result.data)
            if (result.data == "") {
                navigate("/characterMaker")
            }

        } catch (error) {
            const response = {
                message: 'Erro ao buscar status dos módulos',
                error: error
            };

            return response;

        }

    }

    const firstYearCompleted = () => {
        var completed = true;
        modulesStatus.forEach(moduleStatus => {
            if (moduleStatus.sort <= 10 && !moduleStatus.isCompleted) {
                completed = false;
            }
        });
        return completed;
    };

    const modulesCompletedNumber = () => {
        var modulesCompleted = 0
        MODULES.map((module: Module) => {
            modulesStatus.forEach(moduleStatus => {
                if (module.slug === moduleStatus.slug) {
                    if (moduleStatus.isCompleted) {
                        modulesCompleted += 1;
                    }
                }
            })
        })
        return modulesCompleted
    }
    const renderModuleOptions = (module) => {
        var isCompleted: boolean = false;
        var link: string = `/module/${module.id}`;
        var icon = module.image;

        if (modulesCompletedNumber() > 3 && !questionarioRespondido) {
            link = 'questionario'
        }

        if (
            module.sort > 10 &&
            !firstYearCompleted() &&
            !hasPermission('trilogic.admin', userAuth as User)
        ) {
            link = '/';
            icon = lockerIcon;
        }

        isCompleted = module.isCompleted;
            



        return (
            <ModuleOption
                key={module.id as React.Key}
                icon={icon}
                alt={module.name}
                moduleLink={link}
                isCompleted={isCompleted}
            />
        );
    };

    const listaTestes = async () => {
           const a = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/tests/pending`,
            requestConfig
        );

        setTestes (a.data)

        if(a.data.pending) {
            navigate("/pc")
        }

    }

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
            VerificarRespondeuQuestionario(user)
            VerificarNota(user)
        }

    }, []);

    useEffect(() => {
        if (userAuth.token) {
            handleLoadModulesStatus();
            handleCharacter()
            listaTestes()
        }
    }, [userAuth]);

    async function VerificarRespondeuQuestionario(user) {
        try {
            const resposta =  await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/has-answered/${user.id}`)
            console.log(resposta.data.has_answered)
            setRespondido(resposta.data.has_answered)

        } catch {
            setRespondido(true)
        }
    }

    async function VerificarNota(user) {
        //  const resposta =  await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/nota/${user.id}`)

    }

    const trocarNivel = () => {
        if (nivel == 1) {
            setNivel(2)
        } else {
            setNivel(1)
        }
    }

    return (
        <div className={styles.wrapper}>
            {userAuth.token && (
                <>
                    <ProfileBox user={userAuth} />
                    <NavButton
                        icon='quick_reference_all'
                        style={{ right: '2vw', bottom: '1vh', zIndex: '20' }}
                        onClick={showUserManual}
                        title='Mostrar manual'
                    />
                    <NavButton
                        icon='stat_2'
                        style={{ right: '5vw', top: '10vh', zIndex: '20' }}
                        onClick={trocarNivel}
                        title='Proximo Nivel'
                    />

                    {hasPermission('logicmanager.classes', userAuth as User) && (
                        <LogicManagerSidebar />
                    )}
                    <Board wrapperClass={styles.board}>


                        {modulesStatus.find(m => m.id == 13)  && modulesStatus.find(m => m.id == 13)?.isCompleted && nivel == 1 ?

                            <>
                                <div className={styles.title}>Trilogic</div>
                                <div className={styles.moduleWrapper}>

                                    {
                                        modulesStatus.sort((a,b) => a.sort - b.sort).map((module) => (

                                            module.sort < 11 && renderModuleOptions(module)
                                        ))}
                                </div>
                            </>
                            : nivel == 1 && modulesStatus &&

                            <>
                                <div className={styles.title}>Pré-Lógic</div>
                                <div className={styles.moduleWrapper}>
                                    {modulesStatus.find((m)=> m.id ==13) && renderModuleOptions(modulesStatus.find((m)=> m.id ==13) )}
                                </div>
                            </>

                        }

                        {nivel == 2 && <>
                            <div className={styles.title}>Trilogic++</div>
                            <div className={styles.moduleWrapper}>
                                {modulesStatus.map((module) => (

                                    module.sort >= 11 && renderModuleOptions(module)
                                ))}
                            </div>
                        </>}

                    </Board>
                    <BotaoAcessibilidade clicar={() => setShowMenu(current => !current)} />
                    {showAcessibilidade && (
                        <MenuAcessibilidade ModoAcessivel={ModoAcessivel} OnPress={showMenuAcessibilidade} acessivel={acessivel} />
                    )}
                    <MessageBox
                        className={styles.messageBox}
                        content={introFeedback}
                        showMessageBox={showMessageBox}
                        onPress={handleOnPressFeedback}
                    />
                    <Agent className={styles.agent} setShowMessageBox={setShowMessageBox} />
                </>
            )}
        </div>
    );
};
